// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__x3Mle","text_danger":"TablaProducto_text_danger__MSdmf","text_success":"TablaProducto_text_success__EI+Yo"};